import { connectSocketIoThunk, disconnectSocketThunk } from '../socket'
import { refreshAccessToken } from '../../axios/refreshAccessToken'
import { setLogoutWithStorageThunk } from '../registration/auth/withStorage'
import { jwtExpired } from '../../../helper/jwt'
import { logger } from '../../../logger/logger'

export const isSessionRejectedByServer = error => Boolean(error?.response)

export const endSessionThunk = () => (dispatch, getState) => {
	if (!getState().core?.auth?.accessToken) {
		return
	}

	dispatch(disconnectSocketThunk())
	dispatch(setLogoutWithStorageThunk())
}

export const restoreSessionOnResumeThunk = () => async (dispatch, getState) => {
	const accessToken = getState().core?.auth?.accessToken
	if (!accessToken) {
		return
	}

	if (jwtExpired(accessToken)) {
		logger.info('[session] Access token expired while the device was idle, refreshing it before reconnect')
		try {
			await refreshAccessToken()
		} catch (error) {
			if (isSessionRejectedByServer(error)) {
				dispatch(endSessionThunk())
			}

			return
		}
	}

	if (!getState().socket.socketIoClient?.connected) {
		dispatch(connectSocketIoThunk())
	}
}
